import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://txrxiedmmccbgxumgvxm.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InR4cnhpZWRtbWNjYmd4dW1ndnhtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTY0Mjg5MjIsImV4cCI6MjA3MjAwNDkyMn0.2LkM-dDeRL0o5_ZeDUIuvpFEyYSW9VWDJxnFzHG-zs0'

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error('Missing Supabase environment variables')
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})

// Table names with consistent suffix
export const TABLES = {
  FAMILIES: 'families_hh2025',
  CHILDREN: 'children_hh2025', 
  TASKS: 'tasks_hh2025',
  REWARDS: 'rewards_hh2025',
  TASK_COMPLETIONS: 'task_completions_hh2025',
  REWARD_REDEMPTIONS: 'reward_redemptions_hh2025'
}

export default supabase